export const ACOMPTE = {
  title: 'Créer un acompte',
  designation: 'Désignation',
  payeur: 'Choix du payeur',
  devisDesignation: 'Acompte sur devis n°',
  commandeDesignation: 'Acompte sur commande n°',
  modeReglement: 'Mode de règlement',
  dateAcompte: 'Date acompte',
  nbJourDelaiReglement: 'Délai (jours)',
  tva: 'TVA',
  montant: 'Montant TTC',
  commentaire: 'Commentaire',
  nothing: 'Sans',
  create: 'Créer',
  cancel: 'Annuler',
  creationAcompte: '1 Acompte créé',
};

export const VALIDATION_ACOMPTE = {
  dateAcompte: 'Date',
  designation: 'Désignation',
  nbJourDelaiReglement: 'Délai',
  modeReglement: 'Vous devez saisir un mode de règlement pour votre acompte.',
  tiers: 'Vous devez saisir un payeur pour votre acompte.',
  montantTtc: 'Montant TTC',
  montantTtcSupp0: 'Vous devez saisir un montant supérieur à 0.',
  montantGreat: 'Le montant de l\'acompte à ajouter dépasse le montant total du devis ou de la commande.',
  sumMontantGreat: 'La somme des montants des acomptes dépasse le montant total du devis ou de la commande.',
  avoirForbiddenAcompte: 'Création de l\'avoir impossible, l\'acompte est déjà affecté à une facture',
  multiPayerForbidden: 'Impossible de créer un acompte si il y a plusieurs payeurs',
  invoiceCodeMustBeReplacedFully: 'Le code de la facture {param1} n\'a pas pu être généré complètement.',
  accountingAccountRequired: 'Le compte comptable du destinataire comptable est obligatoire.',
  savedStateRRequired: 'Le devis/la commande doit être à l\'état "enregistré"',
  prospectNotAllowed: 'Impossible d\'enregistrer une facture avec un intervenant prospect',
  assistant: 'Assistant(e)',
  commercial: 'Commercial(e)',
};
